import { useRef, useState, ReactNode, cloneElement } from 'react'
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react'
import { createPortal } from 'react-dom'

export interface EmojiPickerButtonProps {
  value: string
  onChange: (emoji: string) => void
  children: ReactNode // The trigger element
}

const EmojiPickerButton = ({ value, onChange, children }: EmojiPickerButtonProps) => {
  const [showPicker, setShowPicker] = useState(false)
  const buttonRef = useRef<HTMLDivElement | null>(null)

  // Clone the trigger and add onClick and ref
  const trigger = cloneElement(children as React.ReactElement, {
    ref: buttonRef,
    onClick: (e: any) => {
      e.preventDefault()
      setShowPicker(true)
      if (
        children &&
        typeof children === 'object' &&
        'props' in children &&
        children.props.onClick
      ) {
        children.props.onClick(e)
      }
    },
  })

  return (
    <>
      {trigger}
      {showPicker &&
        createPortal(
          <div
            onClick={() => setShowPicker(false)}
            style={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              zIndex: 9999,
              top: 0,
              left: 0,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '350px',
                height: '450px',
                position: 'fixed',
                top: buttonRef.current
                  ? buttonRef.current.getBoundingClientRect().y + 34 + 'px'
                  : '0px',
                left: buttonRef.current
                  ? buttonRef.current.getBoundingClientRect().x + 34 + 'px'
                  : '0px',
              }}
            >
              <EmojiPicker
                onEmojiClick={(data) => {
                  onChange(data.emoji)
                  setShowPicker(false)
                }}
                emojiStyle={EmojiStyle.NATIVE}
              />
            </div>
          </div>,
          document.body,
        )}
    </>
  )
}

export default EmojiPickerButton
